if ($(".notamedia-landing__graphics-buttons-item").length > 0) {
	const tabButtons = document.querySelectorAll(".js-tab-button");
	const tabsBlock = document.querySelector(".js-tab");
	const arrowBlock = document.querySelector(".js-tabs-arrow");
	const arrowBlockTwo = document.querySelector(".js-tabs-arrow-2");
	const verticalLine = document.querySelector(".js-vertical-line");
	const tabContents = document.querySelectorAll(".js-tab-content");
	const tabContentsImg = document.querySelectorAll(".js-animate-img");
	const tabGraphButtons = document.querySelectorAll(".js-tab-graph-button");
	const tabGraphIndicator = document.querySelector(
		".notamedia-landing__graphics-indicator"
	);
	const tabGraphContents = document.querySelectorAll(".js-tab-graph-content");
	const graphButtons = document.querySelectorAll(".js-graph-button");
	const graphDescriptions = document.querySelectorAll(
		".js-graph-description-item"
	);
	const graphics = document.querySelectorAll(
		".notamedia-landing__graphics-contents-item"
	);
	const tabContainer = document.querySelector(".notamedia-landing__graphics");
	const tabCollection = document.querySelectorAll(
		".notamedia-landing__graphics-buttons-item"
	);
	const firstTab = tabCollection[0];
	const lastTab = tabCollection[tabCollection.length - 1];
	let firstTabPosition = firstTab.getBoundingClientRect()?.left;
	let lastTabPosition = lastTab.getBoundingClientRect()?.right;
	const gradientWrapper = document.querySelector(
		".notamedia-landing__gradient"
	);

	let inint = JSON.parse(graphics[0].dataset.partials);

	const getPercentAndColor = (data) => ({
		percentArray: data.map((item) => item.percent),
		colorArray: data.map((item) => item.color),
		nameArray: data.map((item) => item.name),
	});

	let nameArr = inint.map((item) => item.name);

	const initPositionArrow = () => {
		if (window.innerWidth > 767) {
			console.log("if");
		} else {
			const wrapperVerticalLine = document.querySelector(
				".notamedia-landing__developed-right-vertical-wrapper"
			);
			const widthBlock = tabsBlock.scrollWidth;
			const posYItem = tabButtons[0].offsetLeft;
			const itemWidth = tabButtons[0].offsetWidth;
			const verticalWidth = verticalLine.offsetWidth;
			const calcLeft = posYItem + (itemWidth / 2 - 8.5) - 20;
			const calcPercentOrGradient =
				((calcLeft + 8.5) * 100) / verticalWidth;

			wrapperVerticalLine.style.width = `${widthBlock}px`;
			verticalLine.style.background = ` linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.7) ${calcPercentOrGradient}%, rgba(255,255,255,0) 100%)`;
			arrowBlockTwo.style.left = `${calcLeft}px`;
		}
	};

	const {
		percentArray: initDataPercentArray,
		colorArray: initDataColorArray,
	} = getPercentAndColor(inint);

	const removeActiveClass = (array) => {
		array.forEach((button) => {
			button.classList.remove("active");
		});
	};
	const updateChart = (dataChart) => {
		if (dataChart) {
			const { percentArray, colorArray, nameArray } =
				getPercentAndColor(dataChart);

			config.data.datasets = [
				{
					label: "",
					data: percentArray,
					backgroundColor: colorArray,
					hoverOffset: 0,
					borderRadius: 12,
					cutout: 172,
				},
			];

			myChart.update();
			nameArr = nameArray;
		} else {
			console.log("нет данных");
		}
	};

	let config = {
		type: "doughnut",
		data: {
			labels: "",
			datasets: [
				{
					label: "",
					data: initDataPercentArray,
					backgroundColor: initDataColorArray,
					hoverOffset: 0,
					borderRadius: 12,
					cutout: 172,
				},
			],
		},
		options: {
			plugins: {
				tooltip: {
					callbacks: {
						label: function (context) {
							if (nameArr[context.dataIndex]) {
								return (context.formattedValue = ` ${
									nameArr[context.dataIndex]
								}: ${context.formattedValue}%`);
							} else {
								return (context.formattedValue = ` ${context.formattedValue}%`);
							}
						},
					},
				},
			},
		},
	};

	const myChart = new Chart(document.getElementById("myChart"), config);

	tabButtons.forEach((item) => {
		item.addEventListener("click", () => {
			const clickTabId = item.attributes[1].value;

			removeActiveClass(tabContents);
			removeActiveClass(tabButtons);
			removeActiveClass(tabContentsImg);

			const posXItem = item.offsetTop;
			const posXBlock = tabsBlock.offsetTop;
			const blockHeight = tabsBlock.offsetHeight;

			if (window.innerWidth > 1200) {
				const calcTop = posXItem - posXBlock;
				const calcPercentOrGradient = (calcTop * 100) / blockHeight;
				verticalLine.style.background = ` linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.7) ${
					100 - calcPercentOrGradient
				}%, rgba(255,255,255,0) 100%)`;
				arrowBlock.style.top = `${calcTop}px`;
			} else if (window.innerWidth > 767) {
				const calcTop = posXItem - posXBlock;
				const calcPercentOrGradient = (calcTop * 100) / blockHeight;
				verticalLine.style.background = ` linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) ${
					100 - calcPercentOrGradient
				}%, rgba(255,255,255,0) 100%)`;
				arrowBlock.style.top = `${calcTop}px`;
			} else {
				const posYItem = item.offsetLeft;
				const itemWidth = item.offsetWidth;
				const verticalWidth = verticalLine.offsetWidth;
				const calcLeft = posYItem + (itemWidth / 2 - 8.5) - 20;
				const calcPercentOrGradient =
					((calcLeft + 8.5) * 100) / verticalWidth;

				verticalLine.style.background = ` linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.7) ${calcPercentOrGradient}%, rgba(255,255,255,0) 100%)`;
				arrowBlockTwo.style.left = `${calcLeft}px`;
			}

			item.classList.add("active");

			tabContents.forEach((el) => {
				if (el.id === clickTabId) {
					el.classList.add("active");
					const imgAnimate = el.querySelector(
						".notamedia-landing__developed-right-content-item-img"
					);

					setTimeout(() => {
						imgAnimate.classList.add("active");
					}, 10);
				}
			});
		});
	});

	tabGraphButtons.forEach((itemGraph) => {
		itemGraph.addEventListener("click", (e) => {
			const clickTabId = itemGraph.attributes[1].value;
			let tabContainerWidth = tabContainer.offsetWidth;
			let itemGraphWidth = itemGraph.offsetWidth;
			let itemGraphLeft = itemGraph.offsetLeft;
			let positionCenter = tabContainerWidth / 2 - itemGraphWidth / 2;
			let scrollLeftUpd = itemGraphLeft - positionCenter;

			tabContainer.scrollTo({
				left: scrollLeftUpd,
				behavior: "smooth",
			});

			removeActiveClass(tabGraphContents);
			removeActiveClass(tabGraphButtons);
			itemGraph.classList.add("active");
			handleIndicator(e.target);

			if (window.innerWidth > 767) {
				setTimeout(function () {
					tabBlur();
				}, 500);
			}

			removeActiveClass(graphDescriptions);

			tabGraphContents.forEach((el) => {
				if (el.id === clickTabId) {
					removeActiveClass(graphButtons);

					el.querySelector(
						".notamedia-landing__graphics-contents-element"
					).classList.add("active");
					el.querySelector(
						".notamedia-landing__graphics-contents-button"
					).classList.add("active");
					el.querySelector(
						".notamedia-landing__graphics-contents-button-minus"
					).classList.add("active");
					el.classList.add("active");

					const dataChart = JSON.parse(el.dataset.partials);
					updateChart(dataChart);
				}
			});
		});
		itemGraph.classList.contains("active") && handleIndicator(itemGraph);
	});

	function tabBlur() {
		if (firstTabPosition !== firstTab.getBoundingClientRect().left) {
			gradientWrapper.classList.add(
				"notamedia-landing__gradient--left-gradient"
			);
		} else {
			gradientWrapper.classList.remove(
				"notamedia-landing__gradient--left-gradient"
			);
		}

		if (lastTabPosition <= lastTab.getBoundingClientRect().right) {
			gradientWrapper.classList.add(
				"notamedia-landing__gradient--right-gradient"
			);
		} else {
			gradientWrapper.classList.remove(
				"notamedia-landing__gradient--right-gradient"
			);
		}
	}

	function handleIndicator(el) {
		tabGraphIndicator.style.width = `${el.offsetWidth}px`;
		tabGraphIndicator.style.left = `${el.offsetLeft}px`;
	}

	graphButtons.forEach((item) => {
		item.addEventListener("click", () => {
			if (
				item
					.closest(".js-graph-description-item")
					.classList.contains("active")
			) {
				removeActiveClass(graphDescriptions);
			} else {
				removeActiveClass(graphDescriptions);
				removeActiveClass(graphButtons);
				item.closest(".js-graph-description-item").classList.add(
					"active"
				);
				item.parentNode
					.querySelector(
						".notamedia-landing__graphics-contents-button-minus"
					)
					.classList.add("active");
				item.classList.add("active");
			}
		});
	});

	function updateTabPosition() {
		firstTabPosition = firstTab.getBoundingClientRect().left;
		lastTabPosition = lastTab.getBoundingClientRect().right;
	}

	window.onresize = function () {
		if (window.innerWidth > 767) {
			updateTabPosition();
			tabBlur();
		}
	};

	window.onload = function () {
		initPositionArrow();
		if (window.innerWidth > 767) {
			tabBlur();
		}
	};
}
